export const seriesListIds = ({ series }) => series.indexIds;
export const series = ({ series }, { seriesId }) => {
  const serie = series.byId[seriesId];
  if (serie) {
    serie.name = serie.name.replace(' Series', '');
    return serie;
  }
  return serie;
};

export const seriesName = ({ series }, { seriesId }) => {
  const serie = series.byId[seriesId];
  if (serie) {
    return serie.name.replace(' Series', '');
  }
  return '';
};

export const seriesByModelId = ({ series, models }, { modelId }) => {
  const { seriesId } = models.byId[modelId];
  const serie = series.byId[seriesId];
  if (serie) {
    serie.name = serie.name.replace(' Series', '');
    return serie;
  }
  return serie;
};

// TODO, if IPA is sending this on the dealership we can use those numbers for dealership summary in the future but depends on if / how we want a more centralized source of truth, ie syncing etc.
export const dealershipSummary = ({ series }) => {
  let dealershipRemainingQuota = 0;
  let dealershipSubmitted = 0;
  series.indexIds.forEach(seriesId => {
    dealershipRemainingQuota += parseInt(
      series.byId[seriesId].remainingQuota,
      10,
    );
    dealershipSubmitted += parseInt(series.byId[seriesId].submitted, 10);
  });
  return {
    remaining: dealershipRemainingQuota,
    submitted: dealershipSubmitted,
  };
};

export const seriesBodyStyleIds = ({ series }, { seriesId }) => {
  const serie = series.byId[seriesId];
  if (serie) {
    return serie.bodyStyles;
  }
};

export const firstModelWithUnsubmitted = ({ series, models }, { seriesId }) => {
  if (series && models) {
    const serieModels = Object.values(models.byId).filter(
      model => model.seriesId === seriesId,
    );

    const serie = series.byId[seriesId];
    const seriesBodyStyleIds = serie.bodyStyles;

    const modelsGroupedByBodyStyles = seriesBodyStyleIds.reduce((modelsArray, bodyStyleId) => {
      let modelsByBodyStyle = serieModels.filter(
        model => model.bodyStyleId === bodyStyleId
      )
      return [...modelsArray, ...modelsByBodyStyle];
    }, [])

    const firstModelWithUnsubmittedQuota = modelsGroupedByBodyStyles.find(
      model => model.unsubmitted > 0,
    );

    if (firstModelWithUnsubmittedQuota) {
      return firstModelWithUnsubmittedQuota.id;
    } else {
      return serieModels[0].id;
    }
  }
};

export const seriesModels = ({ series, models }, { seriesId }) =>
  Object.values(models.byId).filter(model => model.seriesId === seriesId);
